import { red } from '@ant-design/colors';

export default {
  apiDomain: 'api.datapipeplatform.cloud',
  homeUrl: 'scrapula.com',
  company: 'Scrapula',
  id: 'datapipeplatform',
  theme: {
    colorPrimary: red[6],
  },
  contactUsUrl: 'https://scrapula.com/contact-us/',
  servicesUrl: 'https://scrapula.com/services/',
  pricingUrl: 'https://scrapula.com/pricing/',
  faqUrl: 'https://scrapula.com/faq/',
  tutorialsUrl: '',
  videosUrl: '',
  communityUrl: '',
  scheduleCallUrl: '',
  termsOfServiceUrl: 'https://scrapula.com/terms-of-service/',
  googleMapsCategoriesUrl: '',
  stripeApiKeys: {
    main: 'pk_live_51SLP7JHyCbxLrJJgE86QWs36Jqreum3wzQQ7fleBpQfd3emKCM5e10pNQ8lYta8MhS5WCBEm3xx4eMlPd7Yj1IbE005Nu6K4hG',
  },
  payPalClientId: 'AYO6XHLjuGJViw0EwyTsaQOjx2bZ0e-xIxPzxXClY0cVbAw1v2sPx_aOdSs90UyEgySBgS4AuLrva3Ry',
  nmiApiKeys: {
    checkout: 'checkout_public_Dbt8eckgzfu88Nc62WX34mq5mT8w4mS5',
    tokenization: 'FSA52V-9h5CKm-r23a7a-S4r582',
  },
  availablePaymentProviders: {
    nmi: false,
    paypal: true,
    bank: true,
    crypto: true
  },
  gaToken: '',
  googleClientId: '33825443262-u8nfvlush7srkgls26g0i59s9fqqsm82.apps.googleusercontent.com',
  linkedinClientId: '',
  hubspotClientId: null,
  pipedriveClientId: null,
  zohoClientId: null,
  includedServices: [],
  learnMoreLinks: {},
  videoTutorialLinks: {},
  tutorialsLinks: {},
  otherLinks: {},
  integrationsLinks: {}
};
